const setStorage = (key, value) => {
  if (typeof (value) === 'object') {
    value = JSON.stringify(value)
  }
  sessionStorage.setItem(key, value)
}
/*
* 避免刷新之后vuex被重置，在sessionStorage做一个备份
 */
const mutations = {
  set_currency (state, payload) {
    state.currency = payload
    setStorage('currency', payload)
  },
  set_balancePay (state, payload) {
    state.balancePay = payload
    setStorage('balancePay', payload)
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js